// extracted by mini-css-extract-plugin
module.exports = {"Label":"FeatureAttrDialog_Label__1twrw","Spinner":"FeatureAttrDialog_Spinner__AM31Q"};